'use-client';
import * as React from 'react';
import classNames from 'clsx';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import SiteButtonContent from '../../SiteButtonContent';
import type { SkinButtonProps } from '../SkinButton.types';
import SiteButton from '../../SiteButton';
import type {
  ISiteButtonImperativeActions,
  ISiteButtonProps,
} from '../../../SiteButton.types';
import semanticClassNames from '../../../SiteButton.semanticClassNames';
import skinsStyle from './styles/skins.scss';

const ButtonDoubleArrowRightSkin = React.forwardRef<
  ISiteButtonImperativeActions,
  SkinButtonProps
>(
  (
    {
      wrapperProps,
      linkProps,
      a11yProps,
      elementType,
      label,
      onFocus,
      onBlur,
      customClassNames = [],
    },
    ref,
  ) => {
    return (
      <div
        {...wrapperProps}
        className={classNames(
          skinsStyle.ButtonDoubleArrowRight,
          wrapperProps.className,
        )}
      >
        <div className={skinsStyle.wrapper}>
          <div
            className={`${skinsStyle.container} ${skinsStyle.top} ${skinsStyle.left}`}
          >
            <div className={skinsStyle.ribbon} />
          </div>
          <div
            className={`${skinsStyle.container} ${skinsStyle.bottom} ${skinsStyle.left}`}
          >
            <div className={skinsStyle.ribbon} />
          </div>
          <div className={`${skinsStyle.container} ${skinsStyle.right}`}>
            <div className={skinsStyle.ribbon} />
          </div>
          <div className={skinsStyle.filler} />
        </div>
        <SiteButtonContent
          linkProps={linkProps}
          a11yProps={a11yProps}
          elementType={elementType}
          className={classNames(
            skinsStyle.link,
            formatClassNames(semanticClassNames.root, ...customClassNames),
          )}
          onFocus={onFocus}
          onBlur={onBlur}
          ref={ref}
        >
          <span
            className={classNames(
              skinsStyle.label,
              formatClassNames(semanticClassNames.buttonLabel),
            )}
          >
            {label}
          </span>
        </SiteButtonContent>
      </div>
    );
  },
);

const ButtonDoubleArrowLeft: React.ForwardRefRenderFunction<
  ISiteButtonImperativeActions,
  Omit<ISiteButtonProps, 'skin'>
> = (props, ref) => (
  <SiteButton {...props} skin={ButtonDoubleArrowRightSkin} ref={ref} />
);

export default React.forwardRef(ButtonDoubleArrowLeft);
